import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const ConocimientosPrevios = () => {
  
  const { promptData, setPromptData} = useActividadesContext();
  const handleConocimientosPrevios = (event) => {
    const ConocimientosPrevios = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        conocimientos_previos: ConocimientosPrevios 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color:'#336B87' }}>
        Conocimientos previos *
        </Typography>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Indica qué conocimientos o habilidades previas tienen los participantes antes de asistir al taller.
        </FormLabel>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.conocimientos_previos}
          placeholder="Ejemplo: Consciencia sobre las ventajas que ofrece el aprendizaje colaborativo"
          onChange={handleConocimientosPrevios}
          InputProps={{
            sx: {
                borderRadius:2,
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem',
                color: '#005559',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default ConocimientosPrevios;
